module.exports = __webpack_public_path__ + "img/Tutorial_CategoricalDeskriptorStates.8f714844.jpg";